export default __webpack_public_path__ + "static/media/874.755c0a3c.gif";